import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { Area } from "../General/Area";
import { FullScreen } from "../General/FullScreen";
import { Toolbar } from "../General/Toolbar";
import { IconType, MimeTypeIcon } from "../Icons/MimeTypeIcon";
import { ReaderToolbarMode, ReaderToolbarPart } from "./ReaderToolbarPart";

interface ExternalViewProps {
	id: string;
	ext: string;
	docId: string;
	docLanguage: string;
	collectionId: string;
	downloadName: string;
	canDownload: boolean;
	coverAvailable: boolean;
	mimeType: string;
	fileName: string;
	originalFilename: string;
	isDeleted: boolean;
}

@observer
export class ExternalView extends React.Component<ExternalViewProps, {}> {

	@computed get imageUrl(): string {
		let path = encodeURI(`/files/${this.props.id}.cover.jpg`);
		return path;
	}

	render() {
		return <Area>
			<FullScreen>
				<Toolbar>
					<ReaderToolbarPart
						id={this.props.id}
						docId={this.props.docId}
						docLanguage={this.props.docLanguage}
						collectionId={this.props.collectionId}
						downloadName={this.props.downloadName}
						canDownload={this.props.canDownload}
						mode={ReaderToolbarMode.Default}
						fileName={this.props.fileName}
						extension={this.props.ext}
						isDeleted={this.props.isDeleted}
						originalFilename={this.props.originalFilename}
					/>
				</Toolbar>
				<div className="area-grid__body-content">
					<div className="content-main" id="viewer">
						<h1>
							<MimeTypeIcon mimeType={this.props.mimeType} iconType={IconType.Svg} style={{ height: "1em", width: "1em", verticalAlign: "-0.15em" }} />
							<span>&#xa0;</span>
							<span>{this.props.downloadName}</span>
						</h1>
						{
							<img className="external-preview" src={this.props.coverAvailable ? this.imageUrl : "/images/general/No_Preview_Placeholder.svg"} />
						}
					</div>
				</div>
			</FullScreen>
		</Area>;
	}
}